import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild
} from '@angular/core';

import { ComponentTheme, PolicyView } from '@amfam/shared/models';

import '@amfament/embedded-components/policy-view/policy-view.js';

@Component({
  selector: 'app-policy-view-wrapper',
  templateUrl: './policy-view-wrapper.component.html',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PolicyViewWrapperComponent implements OnChanges {
  @Input() policyView: PolicyView;
  @Input() theme: ComponentTheme;

  @Output() eventTriggered = new EventEmitter();
  @ViewChild('policyViewComponent') policyViewComponentRef: ElementRef;

  policy = '';
  data = '';
  defaultTheme = { theme: 'base', resetStateOnInit: false };

  async ngOnChanges() {
    if (this.policyView) {
      await this.initialize();
    }
  }

  onCtaClicked(event) {
    this.eventTriggered.emit({ event, elementRef: this.policyViewComponentRef });
  }

  private async initialize() {
    if (!this.theme) this.theme = this.defaultTheme;
    this.data = JSON.stringify(this.theme);
    const policy = { ...this.policyView };
    console.log(policy);
    this.policy = JSON.stringify(policy);
  }
}
